// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__1Y03d","card-image":"styles_card-image__xDx3e","card-body":"styles_card-body__1phml","title":"styles_title__2NB4c","description":"styles_description__3NOdy"};